/*
 * Define a form page to display fields for a Grant or Contract.
 * First field is always a choice of Grant or Contract.
 * The conditional fields are based on that choice.
 */
import * as yup from 'yup'
import React from 'react'
import { awardType } from '../strings/types'
import {
  contractNumberLabel,
  grantNumberLabel,
  executiveDirectorLabel,
  optionalLabel
} from '../strings/labels'
import { selectionRequired } from '../validators'

export const grantContractPage = propOverrides => {
  const props = {
    index: 0,
    maxIndex: 9,
    pageId: 'grant_contract_page',
    title: 'Is the fraudulent action in relation to a grant or a contract?',
    fieldType: 'radio',
    fieldName: 'award_type',
    choices: [
      { label: awardType.grant, value: awardType.grant },
      { label: awardType.contract, value: awardType.contract }
    ],
    description: '',
    label: '',
    className: 'needed',
    labelClassName: 'needed',
    pageAfterGrant: 'hhs_program_page',
    ...propOverrides
  }

  // Create unique field names based on the field name and the index value.
  const pageId = `${props.pageId}_${props.index}`
  const fieldName = `${props.fieldName}_${props.index}`
  const award_number = `award_number_${props.index}`
  const executive_director = `executive_director_${props.index}`

  // Initial selection of a subject_type is required.
  const awardValidation = yup.object().shape({
    [fieldName]: selectionRequired()
  })

  // Define the fields for Grant
  let grantConditional = {
    value: awardType.grant,
    fields: [
      {
        type: 'text',
        label: grantNumberLabel,
        name: award_number,
        requirementLabel: optionalLabel
      },
      {
        type: 'text',
        label: executiveDirectorLabel,
        name: executive_director,
        requirementLabel: optionalLabel
      }
    ]
  }

  // Define the fields for Contract
  let contractConditional = {
    value: awardType.contract,
    fields: [
      {
        type: 'text',
        label: contractNumberLabel,
        name: award_number,
        requirementLabel: optionalLabel
      },
      {
        type: 'text',
        label: executiveDirectorLabel,
        name: executive_director,
        requirementLabel: optionalLabel
      }
    ]
  }

  let addAnotherConditional = []
  let addAnotherAction = {}
  // When not on the last page, give option to add another
  if (props.index < props.maxIndex) {
    const { addAction, addCondition } = addAnother(
      props,
      awardType.grant,
      awardType.contract
    )
    addAnotherAction = addAction
    addAnotherConditional = [addCondition]
  }

  return {
    id: pageId,
    title: props.title,
    description: props.description,
    validation: awardValidation,
    fields: [
      {
        type: props.fieldType,
        name: fieldName,
        className: props.className,
        choices: props.choices,
        label: props.label,
        labelClassName: props.labelClassName,
        conditionals: [grantConditional, contractConditional].concat(
          addAnotherConditional
        )
      }
    ],
    ...addAnotherAction
  }
}

// Define the field and action to allow the user to add another grant
const addAnother = (props, grant, contract) => {
  const add_award = `add_award_${props.index}`
  const nextAwardPage = `${props.pageId}_${props.index + 1}`
  const addCondition = {
    value: [grant, contract],
    fields: [
      {
        type: 'checkbox',
        label: '',
        name: add_award,
        choices: [
          {
            label: `Add another grant/contract (up to ${props.maxIndex + 1})`,
            value: 'True'
          }
        ],
        requirementLabel: optionalLabel
      }
    ]
  }
  const addAction = {
    action: {
      type: 'goto',
      pageId: values => {
        const add = values[add_award]
        return add.length > 0 ? nextAwardPage : props.pageAfterGrant
      }
    }
  }
  return {
    addAction,
    addCondition
  }
}
